"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FieldInput;

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Autocomplete2 = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _Chip2 = _interopRequireDefault(require("@material-ui/core/Chip"));

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _ArrowDropDownRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownRounded"));

var _Checkbox2 = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _styles = require("@material-ui/styles");

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _icons = _interopRequireDefault(require("../icons"));

var _AttachmentList = _interopRequireDefault(require("./AttachmentList"));

var _DateInput = _interopRequireDefault(require("./DateInput"));

var _LinkToRecordList = _interopRequireDefault(require("./LinkToRecordList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var typeNumber = ["number", "currency", "duration", "percent", "count", "autoNumber", "rating"];
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    labelWrapper: {
      marginBottom: 6,
      "& svg": {
        fontSize: 16,
        marginRight: 6,
        color: theme.palette.text.secondary
      }
    }
  };
});
FieldInput.propTypes = {
  field: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    name: _propTypes["default"].string,
    type: _propTypes["default"].string,
    options: _propTypes["default"].object
  }),
  onChange: _propTypes["default"].func,
  onOpenInput: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  value: _propTypes["default"].any
};

function FieldInput(_ref) {
  var disabled = _ref.disabled,
      field = _ref.field,
      _onChange = _ref.onChange,
      value = _ref.value,
      onOpenInput = _ref.onOpenInput;
  var type = field.type;
  var classes = useStyles();

  var getInput = function getInput() {
    var _field$options3, _field$options4;

    if (type === "checkBox") {
      return /*#__PURE__*/_react["default"].createElement(_Checkbox2["default"], {
        size: "small",
        checked: Boolean(value),
        onChange: function onChange(e) {
          return _onChange(field.name, e.target.checked);
        }
      });
    }

    if (type === "singleSelect" || type === "multiSelect") {
      var _field$options;

      var options = ((_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.options) || [];
      var valueInput = Array.isArray(value) ? value : [];

      if (type === "singleSelect") {
        valueInput = typeof value === "string" ? [{
          value: value
        }] : value !== null && _typeof(value) === "object" ? [value] : [];
      }

      return /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
        id: field.name,
        multiple: true,
        disabled: disabled,
        options: options.filter(function (item) {
          return !valueInput.map(function (v) {
            return v.value;
          }).includes(item.value);
        }),
        getOptionLabel: function getOptionLabel(option) {
          return option.value;
        },
        disableClearable: true,
        popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
        value: valueInput,
        onChange: function onChange(e, data) {
          return _onChange(field.name, type === "multiSelect" ? data : data[data.length - 1]);
        },
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
            InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
              style: {
                fontSize: 14,
                paddingTop: 4,
                paddingBottom: 4,
                minHeight: 38
              }
            }),
            fullWidth: true,
            size: "small",
            variant: "outlined"
          }));
        },
        renderOption: function renderOption(option) {
          return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
            style: {
              color: "white",
              backgroundColor: option.color || "blue"
            },
            size: "small",
            label: option.value,
            color: "primary"
          });
        },
        renderTags: function renderTags(values, getTagProps) {
          return values.map(function (option, index) {
            return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], _extends({
              key: option.value,
              label: option.value,
              style: {
                color: "white",
                backgroundColor: option.color || "blue",
                maxWidth: "35%"
              },
              color: "primary",
              size: "small"
            }, getTagProps({
              index: index
            })));
          });
        }
      });
    }

    if (["collaborator", "createdBy", "updatedBy"].includes(type)) {
      var _options = [];
      var _inputValue = value;

      if (["createdBy", "updatedBy"].includes(type)) {
        _inputValue = value !== null && value !== void 0 && value.firstName ? [_objectSpread(_objectSpread({}, value), {}, {
          value: value === null || value === void 0 ? void 0 : value.firstName
        })] : null;
      }

      if (["collaborator"].includes(type)) {
        _inputValue = Array.isArray(value) ? value.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            value: item.firstName
          });
        }) : null;
      }

      return /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
        id: field.name,
        multiple: true,
        disabled: disabled,
        options: _options,
        getOptionLabel: function getOptionLabel(option) {
          return option.value;
        },
        disableClearable: true,
        openOnFocus: true,
        popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
        value: Array.isArray(_inputValue) ? _inputValue : [],
        onChange: function onChange(e, data) {
          return _onChange(field.name, data);
        },
        onOpen: function onOpen(event) {
          return onOpenInput === null || onOpenInput === void 0 ? void 0 : onOpenInput({
            event: event,
            field: field,
            value: value
          });
        },
        noOptionsText: "Select data",
        placeholder: "Select",
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({}, params, {
            InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
              style: {
                fontSize: 14,
                paddingTop: 4,
                paddingBottom: 4,
                minHeight: 38
              }
            }),
            fullWidth: true,
            size: "small",
            variant: "outlined"
          }));
        },
        renderOption: function renderOption(option) {
          return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
            style: {
              color: "white",
              backgroundColor: option.color || "blue"
            },
            size: "small",
            label: option.value,
            color: "primary"
          });
        },
        renderTags: function renderTags(values, getTagProps) {
          return values.map(function (option, index) {
            return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], _extends({
              key: option.value,
              label: option.value,
              style: {
                color: "white",
                backgroundColor: option.color || "blue",
                maxWidth: "35%"
              },
              color: "primary",
              size: "small"
            }, getTagProps({
              index: index
            }), {
              onDelete: null
            }));
          });
        }
      });
    }

    if (type === "date") {
      var _field$options2;

      var includeTime = (_field$options2 = field.options) === null || _field$options2 === void 0 ? void 0 : _field$options2.includeTimeField;
      var dateValue = value ? (0, _moment["default"])(value, includeTime ? null : "YYYY-MM-DD") : null;
      return /*#__PURE__*/_react["default"].createElement(_Box2["default"], null, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        disabled: disabled,
        id: field.name,
        options: field.options,
        value: dateValue,
        onChange: function onChange(data) {
          var newValue = data.toISOString();

          if (!includeTime) {
            newValue = (0, _moment["default"])(data).format("YYYY-MM-DD");
          }

          _onChange(field.name, newValue);
        }
      }));
    }

    if (["createdAt", "updatedAt"].includes(type)) {
      var _dateValue = value ? (0, _moment["default"])(value) : null;

      return /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        disabled: disabled,
        id: field.name,
        options: {
          includeTimeField: true
        },
        value: _dateValue,
        onChange: function onChange(data) {
          var newValue = data.toISOString();

          _onChange(field.name, newValue);
        }
      });
    }

    if (type === "attachment") {
      return /*#__PURE__*/_react["default"].createElement(_AttachmentList["default"], {
        onUpdate: function onUpdate(data) {
          return _onChange(field.name, data);
        },
        attachments: value,
        onClickAttachFile: function onClickAttachFile(event) {
          return onOpenInput === null || onOpenInput === void 0 ? void 0 : onOpenInput({
            event: event,
            field: field,
            value: value
          });
        }
      });
    }

    if (type === "linkToRecord") {
      return /*#__PURE__*/_react["default"].createElement(_LinkToRecordList["default"], {
        value: value,
        onClickLink: function onClickLink(event) {
          return onOpenInput === null || onOpenInput === void 0 ? void 0 : onOpenInput({
            action: "add",
            event: event,
            field: field,
            value: value
          });
        },
        onClickShowAll: function onClickShowAll(event) {
          return onOpenInput === null || onOpenInput === void 0 ? void 0 : onOpenInput({
            action: "expand",
            event: event,
            field: field,
            value: value
          });
        }
      });
    }

    var isNumber = typeNumber.includes(type);
    var isMultiline = ["longText"].includes(type);
    var fieldType = "text";
    var inputValue = typeof value === "string" ? value : "";
    var allowNegativeNumber = (field === null || field === void 0 ? void 0 : (_field$options3 = field.options) === null || _field$options3 === void 0 ? void 0 : _field$options3.allowNegativeNumber) || (field === null || field === void 0 ? void 0 : (_field$options4 = field.options) === null || _field$options4 === void 0 ? void 0 : _field$options4.negative) || false;

    if (isNumber) {
      fieldType = "number";
      inputValue = value;
    }

    if (type === "email") {
      fieldType = "email";
    }

    if (type === "phone") {
      fieldType = "phone";
    }

    var handleKeyDown = function handleKeyDown(e) {
      if (isNumber && !allowNegativeNumber && e.key === "-") {
        e.preventDefault();
        return false;
      }
    };

    return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], {
      id: field.name,
      fullWidth: true,
      disabled: disabled,
      value: inputValue,
      onKeyDown: handleKeyDown,
      InputProps: {
        style: {
          fontSize: 14
        }
      },
      size: "small",
      type: fieldType,
      variant: "outlined",
      onChange: function onChange(e) {
        return _onChange(field.name, isNumber ? e.target.value === "" ? null : Number(e.target.value) : e.target.value);
      },
      multiline: isMultiline,
      minRows: isMultiline ? 3 : 1
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: field.name
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    className: classes.labelWrapper,
    display: "flex",
    alignItems: "center"
  }, _icons["default"][field.type], /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    color: "textSecondary",
    variant: "body2"
  }, field.name))), getInput());
}